<template>
    <el-pagination background layout="prev, pager, next" hide-on-single-page :pager-count="5"
        :current-page="pagination.page" :page-size="pagination.size" :total="pagination.total" prev-text="上一页"
        next-text="下一页" @current-change="currentChange" @size-change="sizeChange">
    </el-pagination>
</template>

<script>
export default {
    name: 'PaginationComp',
    props: {
        pagination: {
            type: Object,
            default: () => {
                return {
                    total: 0,
                    page: 1,
                    size: 20,
                }
            }
        }
    },
    data() {
        return {

        }
    },
    methods: {
        currentChange(val) {
            this.$emit('currentChange', val);
        },
        sizeChange(val) {
            this.$emit('sizeChange', val);
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/.el-pagination.is-background {
    .btn-next,
    .btn-prev,
    .el-pager li {
        background-color: white;
        border: 1px solid rgba(0, 0, 0, 0.16);
        border-radius: 4px;

        &:not(.disabled).active {
            border-color: #FF8E2A;
            background-color: #FF8E2A;
            color: white;
        }

        &:not(.disabled):not(.active):not([disabled="disabled"]):hover {
            color: #FF8E2A;
        }
    }

    .btn-next,
    .btn-prev {
        padding-left: 10px;
        padding-right: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pagination/PaginationComp.vue